import { render, staticRenderFns } from "./Campaign2025.vue?vue&type=template&id=20dcc8b4"
import script from "./Campaign2025.vue?vue&type=script&setup=true&lang=js"
export * from "./Campaign2025.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Campaign2025.vue?vue&type=style&index=0&id=20dcc8b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports